<mat-form-field #bottonSheet class="fullWidthBtn">
      <div class="pointer dateStyle" (click)="openBottomSheet()">
          <mat-icon title="Modificar rango de fecha" class="darkGreyLynx verticalCenteredIcon unselectable">today</mat-icon>
            <input class="pointer inputFecha" disabled="disabled" matInput [(ngModel)]="dateSelected">  
      </div>
</mat-form-field>